/* @flow */

import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import styled from '@emotion/styled';
import moment from 'moment';

const Cell = styled.div(({ important, highlight, separate, theme }) => ({
  alignItems: 'center',
  borderRight: separate ? '1px solid #ececec' : 0,
  borderBottom: '1px solid #ececec',
  display: 'flex',
  fontWeight: highlight && theme.fontWeight.bold,
  color: highlight && theme.color.widgetPrimary,
  justifyContent: 'center',
  padding: '0 0.5em',
  textTransform: important ? 'uppercase' : 'initial',
  whiteSpace: 'nowrap'
}));

const connector = connect((state, ownProps) => {
  const { columnIndex, style, data, categories } = ownProps;

  const statKey = get(`[${columnIndex}].id`, categories);
  const columnValue = get(statKey, data.stats) ? get(statKey, data.stats) : '-';

  return {
    children: statKey === 'date' ? moment(columnValue).format('DD MMM') : columnValue,
    style
  };
}, {});

export default connector(Cell);
